module.exports = __webpack_public_path__ + "img/lite.f69269ca.png";